import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { SeoService } from '@core/services/seo.service';
import { environment } from '@environment';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { SeoLink } from '@models/seo/seo-link';
import { SeoTypeEnum } from '@models/seo/seo-type.enum';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { DirectoriesRoutingEnum } from '@routing/directories/directories-routing.enum';
import { GetDirectory, GetInitialDirectories } from '@store/seo/seo.actions';
import { SeoState } from '@store/seo/seo.state';
import { buildPath } from '@wizbii/angular-utilities';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobsComponent implements OnInit, OnDestroy {
  private directoryId: string;
  basePath = buildPath(FeaturesRoutingEnum.Directories, DirectoriesRoutingEnum.Jobs);
  letter: string;
  page: string;

  initials$: Observable<string[]>;
  links$: Observable<SeoLink[]>;

  private metaElements: HTMLMetaElement[] = [];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly store: Store,
    private readonly seoService: SeoService,
    private readonly metaService: Meta
  ) {}

  ngOnInit(): void {
    this.route.params.pipe(untilDestroyed(this)).subscribe((params) => {
      this.letter = params['letter'];
      this.page = params['page'];

      this.initials$ = this.store.select(SeoState.initials(SeoTypeEnum.job));

      this.store.dispatch(new GetInitialDirectories(SeoTypeEnum.job, environment.locale));

      if (this.letter) {
        this.directoryId = this.seoService.getDirectoryId(SeoTypeEnum.job, environment.locale, this.letter, this.page);

        this.links$ = this.store.select(SeoState.links(SeoTypeEnum.job, this.directoryId));

        this.store.dispatch(new GetDirectory(SeoTypeEnum.job, this.directoryId));
      }
      this.metaElements = [
        this.metaService.addTag({
          name: 'robots',
          content: 'index,follow',
        }),
      ];
    });
  }

  ngOnDestroy(): void {
    this.metaElements.forEach((meta) => {
      this.metaService.removeTagElement(meta);
    });
  }
}
